import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#d9e1dc",
        textAlign: "center",
        padding: "15px",
        marginTop: "auto", // ensures it goes to the bottom if content is short
      }}
    >
      Copyright © 2025 Heona Liu
    </footer>
  );
};

export default Footer;
